import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import type {
  Contract,
  ContractDetail,
  ContractHistoryVersion,
  ContractedInsuranceEntity
} from '@/types/contract';
import type { QueryParams } from '@/types/query';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/contracts';

export const dugoutContractRepository = createRepository<Contract, never>(basePath);

const DugoutContractRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return dugoutContractRepository.list({ host, params });
    },

    async detail(id: string): Promise<ContractDetail> {
      const response = await ajax.get({ url: `${host}${basePath}/${id}/` });
      return response.data as ContractDetail;
    },

    async versionHistory(id: string): Promise<ContractHistoryVersion[]> {
      const response = await ajax.get({ url: `${host}${basePath}/${id}/version_history/` });
      return response.data as ContractHistoryVersion[];
    },

    async insuranceEntities(id: string): Promise<ContractedInsuranceEntity[]> {
      const response = await ajax.get({ url: `${host}${basePath}/${id}/insurance_entities/` });
      return response.data as ContractedInsuranceEntity[];
    }
  };
};

export default DugoutContractRepository;
